import { render } from "./WorkIcon.vue?vue&type=template&id=24ae0d1c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/WorkIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24ae0d1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24ae0d1c', __exports__)) {
    api.reload('24ae0d1c', __exports__)
  }
  
  module.hot.accept("./WorkIcon.vue?vue&type=template&id=24ae0d1c", () => {
    api.rerender('24ae0d1c', render)
  })

}


export default __exports__